import Error from "../pages/common/Error";
import TechnicalMap from "../pages/organization/orders/TechnicalMap";
import TechnicalMaps from "../pages/organization/orders/TechnicalMaps";
import WorkerJob from "../pages/organization/orders/WorkerJob";
import Orders from "../pages/organization/orders/order/Orders";
import OrderItem from "../pages/organization/orders/order/OrderItem";
import Constructors from "../pages/organization/orders/Constructors";
import PackagingSetItem from "../pages/organization/model-estimate/packaging/PackagingSetItem";
import PackagingSetItemAddUnit from "../pages/organization/model-estimate/packaging/PackagingSetItemAddUnit";
import ModelSetPackagingSet from "../pages/organization/model-estimate/models/ModelSetPackagingSet";
import Archive from "../pages/organization/orders/order/Archive";
import SetAttributeOrder from "../pages/organization/orders/order/SetAttributeOrder";
import React from "react";
import Users from "../pages/common/Users";
import UsersItem from "../pages/organization/orders/UsersItem";
import Paths from "../pages/organization/orders/Paths";
import Materials from "../pages/organization/storage/material/material/Materials";
import Units from "../pages/organization/storage/Units";
import CustomerOrderOffers from "../pages/customer/orders/CustomerOrderOffers";
import CurrentCurrencyNationalBank from "../pages/organization/storage/price/CurrentCurrencyNationalBank";
import MaterialItem from "../pages/organization/storage/material/material/MaterialItem";
import ArrivalMaterial from "../pages/organization/storage/material/arrival/ArrivalMaterial";
import ArrivalMaterialPriceUnit from "../pages/organization/storage/material/arrival/ArrivalMaterialPriceUnit";
import SupplierItem from "../pages/organization/storage/supplier/SupplierItem";
import ArrivalMaterialArchive from "../pages/organization/storage/material/arrival/ArrivalMaterialArchive";
import ArrivalMaterialPriceUnitArchive
    from "../pages/organization/storage/material/arrival/ArrivalMaterialPriceUnitArchive";
import RequestsCuttingsAll from "../pages/organization/optimization/requestscutting/RequestsCuttingsAll";
import WarehouseFinishedDetail from "../pages/organization/cutting/warehousefinisheddetail/WarehouseFinishedDetail";
import WorkingCuttingMaps from "../pages/organization/cutting/workingcuttingmap/WorkingCuttingMaps";
import WorkingCuttingMapItem from "../pages/organization/cutting/workingcuttingmap/WorkingCuttingMapItem";
import RequestCustomizedMaterials
    from "../pages/organization/optimization/requestcustomizedmaterials/RequestCustomizedMaterials";
import RequestCustomizedMaterialsDetails
    from "../pages/organization/optimization/requestcustomizedmaterialsdetails/RequestCustomizedMaterialsDetails";
import Optimizations from "../pages/organization/optimization/optimization/Optimizations";
import RequestsCuttingOptimization
    from "../pages/organization/optimization/requestscutting/RequestsCuttingOptimization";
import DetailsRequestsCuttingOptimization
    from "../pages/organization/optimization/requestscutting/details/DetailsRequestsCuttingOptimization";
import DetailsRequestsCutting from "../pages/organization/optimization/requestscutting/details/DetailsRequestsCutting";
import Plans from "../pages/organization/optimization/plans/Plans";
import PlanItem from "../pages/organization/optimization/plans/PlanItem";
import RequestsCuttingPlan from "../pages/organization/optimization/requestscutting/RequestsCuttingPlan";
import RequestsPurchase from "../pages/organization/storage/purchase/RequestsPurchase";
import FormationRequestsPurchase from "../pages/organization/storage/purchase/FormationRequestsPurchase";
import RequestsPurchaseItem from "../pages/organization/storage/purchase/RequestsPurchaseItem";
import ReservationPieceMaterial from "../pages/organization/orders/reservation/ReservationPieceMaterial";
import ReservationSlabMaterial from "../pages/organization/orders/reservation/ReservationSlabMaterial";
import ArrivalMaterialItem from "../pages/organization/storage/material/arrival/ArrivalMaterialItem";
import SupplierMaterialArchiveItem
    from "../pages/organization/storage/material/suppliermaterial/SupplierMaterialArchiveItem";
import MaterialFixedStripeArchiveItem
    from "../pages/organization/storage/material/suppliermaterial/MaterialFixedStripeArchiveItem";
import MaterialMinStripeArchiveItem
    from "../pages/organization/storage/material/suppliermaterial/MaterialMinStripeArchiveItem";
import ReservationMaterialEstimateUnit from "../pages/organization/orders/reservation/ReservationMaterialEstimateUnit";
import RequestsCuttingCalculation from "../pages/organization/optimization/requestscutting/RequestsCuttingCalculation";
import OptimizationsCalculation from "../pages/organization/optimization/optimization/OptimizationsCalculation";
import WorkingCuttingMapsCalculation
    from "../pages/organization/cutting/workingcuttingmap/WorkingCuttingMapsCalculation";
import WorkingCuttingMapsCalculationArchive
    from "../pages/organization/cutting/workingcuttingmap/WorkingCuttingMapsCalculationArchive";
import WorkingCuttingMapsArchive from "../pages/organization/cutting/workingcuttingmap/WorkingCuttingMapsArchive";
import ReservationLinerMaterial from "../pages/organization/orders/reservation/ReservationLinerMaterial";
import AllMaterials from "../pages/material-cloud/admin/AllMaterials";
import AllMaterialItem from "../pages/material-cloud/admin/AllMaterialItem";
import OrganizationSupplierMaterialArchiveItem
    from "../pages/organization/storage/material/suppliermaterial/organization/OrganizationSupplierMaterialArchiveItem";
import OrganizationMaterialFixedStripeArchiveItem
    from "../pages/organization/storage/material/suppliermaterial/organization/OrganizationMaterialFixedStripeArchiveItem";
import OrganizationMaterialMinStripeArchiveItem
    from "../pages/organization/storage/material/suppliermaterial/organization/OrganizationMaterialMinStripeArchiveItem";
import RatingsWorker from "../pages/organization/orders/worker/RatingsWorker";
import BasicModelsEstimate from "../pages/organization/model-estimate/estimate/BasicModelsEstimate";
import BasicModelsMaterialEstimateUnit
    from "../pages/organization/model-estimate/estimate/BasicModelsMaterialEstimateUnit";
import ModelReplacement from "../pages/organization/model-estimate/models/ModelReplacement";
import CutFile from "../pages/organization/cutting/workingcuttingmap/CutFile";
import AllIssuanceMaterialReserve from "../pages/organization/economic/AllIssuanceMaterialReserve";

import SettingsCloud from "../pages/material-cloud/admin/SettingsCloud";
import SettingsCloudLoadGroupMaterial from "../pages/material-cloud/admin/SettingsCloudLoadGroupMaterial";
import SettingsCloudLoadMaterial from "../pages/material-cloud/admin/SettingsCloudLoadMaterial";
import IssuingEdges from "../pages/organization/prodaction/IssuingEdges";
import IssuingEdge from "../pages/organization/prodaction/IssuingEdge";
import IssuanceWarehouseMaterial from "../pages/organization/prodaction/issuance/IssuanceWarehouseMaterial";
import IssuanceWarehouseMaterialCurrentIssuingEdge
    from "../pages/organization/prodaction/issuance/IssuanceWarehouseMaterialCurrentIssuingEdge";
import IssuanceIssuingEdgesItem from "../pages/organization/prodaction/IssuanceIssuingEdgesItem";
import IssuanceMaterialReserve from "../pages/organization/prodaction/issuance/IssuanceMaterialReserve";
import IssuancePieceMaterials from "../pages/organization/prodaction/issuance/IssuancePieceMaterials";
import IssuancePieceMaterialsItem from "../pages/organization/prodaction/issuance/IssuancePieceMaterialsItem";
import IssuanceReservationMaterialEstimateUnit
    from "../pages/organization/prodaction/issuance/IssuanceReservationMaterialEstimateUnit";
import InWork from "../pages/organization/prodaction/issuance/InWork";

import SignJob from "../pages/organization/prodaction/productioncosts/SignJob";
import OrdersProduction from "../pages/organization/prodaction/OrdersProduction";
import QueueCuttingMaps from "../pages/organization/cutting/workingcuttingmap/QueueCuttingMaps";
import CustomerOrders from "../pages/customer/orders/CustomerOrders";
import CustomerOrderItem from "../pages/customer/orders/CustomerOrderItem";
import CustomerOrderCompositionPage from "../pages/customer/orders/CustomerOrderCompositionPage";
import OrdersForWriteOff from "../pages/organization/orders/order/OrdersForWriteOff";
import CustomerRequestsCutting from "../pages/customer/details/CustomerRequestsCutting"
import Processing from "../pages/customer/processing/Processing";
import OrdersCloud from "../pages/organization/orders/order-cloud/OrdersCloud";
import OrdersComposition from "../pages/organization/orders/order-composition/OrdersComposition";
import OrderCompositionItem from "../pages/organization/orders/order-composition/OrderCompositionItem";
import CustomerOrganizationEstimateItem from "../pages/customer/orders/CustomerEstimateOrganizationItem";
import OrderCloudItem from "../pages/organization/orders/order-cloud/OrderCloudItem";
import OrdersEconomic from "../pages/organization/economic/OrdersEconomic";
import OrganizationEstimate from "../pages/organization/orders/estimate/OrganizationEstimate";
import CustomerOrdersArchive from "../pages/customer/orders/CustomerOrdersArchive";
import SamplesEdges from "../pages/customer/samples/SamplesEdges";
import SamplesGroups from "../pages/customer/samples/groups/SamplesGroups";
import Samples from "../pages/customer/samples/samples/Samples";
import Work from "../pages/common/Work";
import SettingsSignJob from "../pages/common/settings/SettingsSignJob";
import SettingsMetricJob from "../pages/common/settings/SettingsMetricJob";
import NewsAndStock from "../pages/common/NewsAndStock";
import NewsDetail from "../pages/common/NewsDetail";
import Help from "../pages/common/Help";
import Contacts from "../pages/common/Contacts";
import HowToOrder from "../pages/common/HowToOrder";
import RequestsCuttingCalculationOptimization
    from "../pages/organization/optimization/requestscutting/RequestsCuttingCalculationOptimization";
import OptimizationsArchive from "../pages/organization/optimization/optimization/OptimizationsArchive";
import OptimizationsCalculationArchive
    from "../pages/organization/optimization/optimization/OptimizationsCalculationArchive";
import ReservationMaterialEstimateUnitPurchase
    from "../pages/organization/orders/reservation/ReservationMaterialEstimateUnitPurchase";
import OrdersCloudArchive from "../pages/organization/orders/order-cloud/OrdersCloudArchive";
import UserRoles from "../pages/common/settings/UserRoles";
import MaterialWarehouseArchive
    from "../pages/organization/storage/material/warehousematerial/MaterialWarehouseArchive";
import IssuingEdgesArchive from "../pages/organization/prodaction/IssuingEdgesArchive";
import DetailReserve from "../pages/organization/DetailReserve";
import DetailWarehouse from "../pages/organization/DetailWarehouse";
import Salary from "../pages/organization/economic/Salary";
import ArchiveNotImplemented from "../pages/organization/orders/order/ArchiveNotImplemented";
import RequestsCuttingsArchive from "../pages/organization/optimization/requestscutting/RequestsCuttingsArchive";
import InStock from "../pages/organization/prodaction/issuance/InStock";
import SettingsPostprocessors from "../pages/common/settings/SettingsPostprocessors";
import PlanningTable from "../components/UI/table/orders/organization/planning/Planning";
import DevelopedTable from "../components/UI/table/orders/organization/developed/DevelopedTable";
import ExportingSupplyRequestsColumns from "../pages/common/settings/ExportingSupplyRequestsColumns";
import ReserveWareHouseTable from "../pages/organization/ReserveWareHouseTable";
import ReserveMaterial from "../pages/organization/ReserveMaterial";
import ReserveArrival from "../pages/organization/ReserveMaterial";
import {
    ArrivalMaterialItemFromIssuance
} from "../pages/organization/storage/material/arrival/ArrivalMaterialItemFromIssuance";
import {
    ArrivalMaterialItemReserveWarehouse
} from "../pages/organization/storage/material/arrival/ArrivalMaterialItemReserveWarehouse";
import {
    ArrivalMaterialItemReserveArrival
} from "../pages/organization/storage/material/arrival/ArrivalMaterialItemReserveArrival";
import IssuingEdgeReservation from "../pages/organization/orders/reservation/IssuingEdgeReservation";
import {
    ArrivalMaterialItemReserveIssuingEdge
} from "../pages/organization/storage/material/arrival/ArrivalMaterialItemReserveIssuingEdge";
import {
    CustomerOrderItemImport3DMessages
} from "../components/UI/table/orders/customer/order/CustomerOrderItemImport3DMessages";
import BalanceSheet from "../pages/organization/prodaction/issuance/BalanceSheet";
import MaterialWarehouseChildren
    from "../pages/organization/storage/material/warehousematerial/MaterialWarehouseChildren";
import ModulesItem from "../pages/common/settings/ModulesItem";
import ModuleCompositionItem from "../pages/common/settings/ModuleCompositionItem";
import DependentModuleCompositionItem from "../pages/common/settings/DependentModuleCompositionItem";
import PatternsItem from "../pages/common/settings/PatternsItem";
import PacedDetailModuleItem from "../pages/common/settings/PacedDetailModuleItem";
import CompositionItem from "../pages/common/settings/CompositionItem";
import PlanningEconomic from "../pages/organization/economic/PlanningEconomic";
import Catalog from "../pages/common/Catalog";
import CatalogDrafts from "../pages/common/CatalogDrafts";
import NotConstructedEconomic from "../pages/organization/economic/NotConstructedEconomic";
import OrdersCustomerProduction from "../pages/customer/orders/OrdersCustomerProduction";
import CatalogItem from "../pages/common/CatalogItem";
import CompositionPicturesMedia from "../pages/common/settings/CompositionPicturesMedia";

//Calculation
export const Calculation = [
    'ROLE_CALCULATION_USER'
]

export const CalculationRequestsCutting = [
    'ROLE_CALCULATION_REQUESTS_CUTTING_USER'
]

export const CalculationOptimizations = [
    'ROLE_CALCULATION_OPTIMIZATIONS_USER'
]

export const CalculationWorkingCuttingMaps = [
    'ROLE_CALCULATION_WORKING_CUTTING_MAPS_USER'
]

//orders
export const OrdersUser = [
    'ROLE_ORDERS_USER'
]

export const ConstructorsUser = [
    'ROLE_ORDERS_CONSTRUCTOR_USER'
]

export const OrdersArchive = [
    'ROLE_ORDERS_ARCHIVE_USER'
]

export const OrdersToArchive = [
    'ROLE_ORDERS_TO_ARCHIVE_USER'
]

export const OrdersSettings = [
    'ROLE_ORDERS_SETTINGS_USER'
]

//technicalMap
export const OrdersTechnicalMap = [
    'ROLE_TECHNICAL_MAP_USER'
]
export const OrdersWorkerJob = [
    'ROLE_WORKER_JOB_USER'
]

//Estimate
export const OrdersEstimates = [
    'ROLE_ESTIMATE_USER'
]

//Optimization
export const Optimization = [
    'ROLE_OPTIMIZATION_USER'
]

export const RequestsCutting = [
    'ROLE_OPTIMIZATION_REQUESTS_CUTTING_USER'
]

export const RequestsCustomizedMaterials = [
    'ROLE_OPTIMIZATION_REQUESTS_CUSTOMIZED_MATERIALS'
]

export const CustomizedMaterialsDetails = [
    'ROLE_OPTIMIZATION_CUSTOMIZED_MATERIALS_DETAILS_USER'
]

export const Plan = [
    'ROLE_OPTIMIZATION_PLAN_USER'
]

export const OptimizationOptimization = [
    'ROLE_OPTIMIZATION_OPTIMIZATION_USER'
]

//storage
export const Storage = [
    'ROLE_STORAGE_USER'
]

export const StorageMaterials = [
    'ROLE_STORAGE_MATERIALS_USER'
]

export const StorageRequestsPurchase = [
    'ROLE_STORAGE_REQUESTS_PURCHASE_USER'
]

export const StorageReservationPieceMaterial = [
    'ROLE_STORAGE_RESERVATION_PIECE_MATERIAL_USER'
]

export const StorageReservationSlabMaterial = [
    'ROLE_STORAGE_RESERVATION_SLAB_MATERIAL_USER'
]

export const StorageReservationLinearMaterial = [
    'ROLE_STORAGE_RESERVATION_LINEAR_MATERIAL_USER'
]

export const StorageMaterialsArrival = [
    'ROLE_STORAGE_MATERIALS_ARRIVAL_USER'
]

export const StorageCurrentCurrencies = [
    'ROLE_STORAGE_CURRENT_CURRENCIES_USER'
]

export const StorageSettingsStorage = [
    'ROLE_STORAGE_SETTINGS_STORAGE_USER'
]

//Cutting
export const Cutting = [
    'ROLE_CUTTING_USER'
]

export const CuttingWorkingCuttingMaps = [
    'ROLE_CUTTING_WORKING_CUTTING_MAPS_USER'
]

export const CuttingQueueCuttingMaps = [
    'ROLE_CUTTING_QUEUE_CUTTING_MAPS_USER'
]

export const CuttingWarehouseFinishedDetail = [
    'ROLE_WAREHOUSE_FINISHED_DETAIL_USER'
]

//PRODUCTION
export const OrderPRODUCTION = [
    'ROLE_PRODUCTION_USER'
]

export const OrderPRODUCTIONPRODUCTION = [
    'ROLE_PRODUCTION_PRODUCTION_USER'
]

export const OrderPRODUCTIONIssuingEdges = [
    'ROLE_PRODUCTION_ISSUING_EDGES_USER'
]

export const OrderPRODUCTIONIssuancePieceMaterials = [
    'ROLE_PRODUCTION_ISSUANCE-PIECE-MATERIALS_USER'
]

//economic
export const Economic = [
    'ROLE_ECONOMIC_USER'
]

export const EconomicIssuanceMaterialReserve = [
    'ROLE_ECONOMIC_ISSUANCE_MATERIAL_RESERVE_USER'
]

export const EconomicInWork = [
    'ROLE_ECONOMIC_IN_WORK_USER'
]

//Material_cloud
export const MaterialCloudAdminRoles = [
    'ROLE_MATERIAL_CLOUD_SUPER_USER'
]

export const MaterialCloud = [
    'ROLE_MATERIAL_CLOUD_USER'
]

export const CustomerRoles = [
    'CUSTOMER'
]

//Customer_requestsCutting_cutting
export const CustomerRequestsCuttingRoles = [
    'ROLE_CUSTOMER_REQUESTS_CUTTING_USER'
]
export const CustomerProcessing = ['ROLE_CUSTOMER_PROCESSING_USER']


export const routes = [
    //common
    {
        component: <Help/>,
        path: '/help',
        errorElement: Error,
    },
    {
        component: <HowToOrder/>,
        path: '/how-to-order',
        errorElement: Error,
    },
    {
        component: <Contacts/>,
        path: '/contacts',
        errorElement: Error,
    },
    {
        component: <Work/>,
        path: '/work',
        errorElement: Error,
    },
    {
        component: <Catalog/>,
        path: '/catalog',
        search: '?type=type',
        errorElement: Error,
    },
    {
        component: <CatalogDrafts/>,
        path: '/catalog/drafts',
        errorElement: Error,
    },
    {
        component: <CatalogItem/>,
        path: '/catalog/:id',
        errorElement: Error,
    },
    {
        component: <NewsAndStock news={true}/>,
        path: '/news',
        errorElement: Error,
    },
    {
        component: <NewsAndStock/>,
        path: '/stock',
        errorElement: Error,
    },
    {
        component: <NewsDetail news={true}/>,
        path: '/news/:id',
        errorElement: Error,
    },
    {
        component: <NewsDetail/>,
        path: '/stock/:id',
        errorElement: Error,
    },
    {
        component: <SettingsSignJob/>, path: '/settings/signJob/:id', errorElement: Error,
    },
    {
        component: <SettingsPostprocessors/>, path: '/settings/postprocessor/:id', errorElement: Error,
    },
    {
        component: <SettingsMetricJob/>, path: '/settings/metricJob/:id', errorElement: Error,
    },
    {
        component: <UserRoles/>, path: '/settings/userRoles/:id', errorElement: Error,
    },
    {
        component: <CompositionPicturesMedia/>, path: '/settings/composition-media/:id/:name', errorElement: Error,
    },
    {
        component: <ExportingSupplyRequestsColumns/>,
        path: '/settings/columns-arrival-material-export/:id',
        errorElement: Error,
    },

    //calculation
    {
        component: <RequestsCuttingCalculation/>,
        path: '/organization/requests-cutting/calculation',
        errorElement: Error,
        roles: CalculationRequestsCutting
    },
    {
        component: <OptimizationsCalculation/>, path: '/organization/optimizations-calculation', errorElement: Error,
        roles: CalculationOptimizations
    },
    {
        component: <OptimizationsCalculationArchive/>,
        path: '/organization/optimizations-calculation-archive',
        errorElement: Error,
        roles: CalculationOptimizations
    },
    {
        component: <WorkingCuttingMapsCalculation/>,
        path: '/organization/working-cutting-maps-calculation',
        errorElement: Error,
        roles: CalculationWorkingCuttingMaps
    },

    {component: <OrdersCloud/>, path: '/organization/orders-cloud', errorElement: Error, roles: OrdersUser},
    {component: <OrdersComposition/>, path: '/organization/orders-composition', errorElement: Error, roles: OrdersUser},
    {
        component: <OrderCompositionItem/>,
        path: '/organization/orders-composition/:orderId/:numberCustomer',
        errorElement: Error,
        roles: OrdersUser
    },
    {
        component: <OrdersCloudArchive/>,
        path: '/organization/orders-cloud-archive',
        errorElement: Error,
        roles: OrdersUser
    },
    {
        component: <OrderCloudItem/>,
        path: '/organization/orders-cloud/:orderId/:numberCustomer',
        errorElement: Error,
        roles: OrdersUser
    },

    //orders
    //*OrdersUser*
    {component: <Orders/>, path: '/organization/orders', errorElement: Error, roles: OrdersUser},
    {component: <OrdersEconomic/>, path: '/organization/orders/economic', errorElement: Error, roles: OrdersUser},
    {component: <PlanningEconomic/>, path: '/organization/economic/planning', errorElement: Error, roles: OrdersUser},
    {
        component: <NotConstructedEconomic/>,
        path: '/organization/economic/not-constructed',
        errorElement: Error,
        roles: OrdersUser
    },
    {
        component: <SetAttributeOrder/>,
        path: '/organization/orders/set-attribute/:id/:number/:idHeader/:year',
        errorElement: Error,
        roles: OrdersUser
    },
    {component: <Constructors/>, path: '/organization/constructors', errorElement: Error, roles: OrdersSettings},
    {
        component: <DevelopedTable/>,
        path: '/organization/constructors/developed',
        errorElement: Error,
        roles: OrdersSettings
    },
    {component: <PlanningTable/>, path: '/organization/planning', errorElement: Error, roles: OrdersSettings},
    {component: <Archive/>, path: '/organization/archive', errorElement: Error, roles: OrdersArchive},
    {
        component: <ArchiveNotImplemented/>,
        path: '/organization/not-implemented',
        errorElement: Error,
        roles: OrdersArchive
    },
    {component: <OrdersForWriteOff/>, path: '/organization/for-write-off', errorElement: Error, roles: OrdersToArchive},
    //model-estimate
    {
        component: <BasicModelsEstimate/>,
        path: '/organization/basic-models/:id/estimates/',
        errorElement: Error,
        roles: OrdersSettings
    },
    {
        component: <BasicModelsMaterialEstimateUnit/>,
        path: '/organization/basic-models/:id/estimates/:estimateId/:estimateNumber',
        errorElement: Error,
        roles: OrdersSettings
    },
    {component: <SignJob/>, path: '/organization/PRODUCTIONCosts', errorElement: Error, roles: OrdersSettings},
    {
        component: <ModelReplacement/>,
        path: '/organization/models/replacements/:id',
        errorElement: Error,
        roles: OrdersSettings
    },
    //models
    {
        component: <ModelSetPackagingSet/>,
        path: '/organization/models/set-packaging-set/:id/:article',
        errorElement: Error,
        roles: OrdersSettings
    },
    {
        component: <PackagingSetItem/>,
        path: '/organization/packaging-sets/:id/:article',
        errorElement: Error,
        roles: OrdersSettings
    },
    {
        component: <CompositionItem/>,
        path: '/organization/composition/:id',
        errorElement: Error,
        roles: OrdersSettings
    },
    {
        component: <DependentModuleCompositionItem/>,
        path: '/organization/dependent-module-composition/:id',
        errorElement: Error,
        roles: OrdersSettings
    },
    {
        component: <ModuleCompositionItem/>,
        path: '/organization/module-composition/:id',
        errorElement: Error,
        roles: OrdersSettings
    },
    {
        component: <ModulesItem/>,
        path: '/organization/module/:id',
        errorElement: Error,
        roles: OrdersSettings
    },
    {
        component: <ModulesItem/>,
        path: '/organization/module/:id/depend/:parentId/:parentName',
        errorElement: Error,
        roles: OrdersSettings
    },
    {
        component: <PatternsItem/>,
        path: '/organization/module/:moduleId/:moduleName/patterns/:id/:name',
        errorElement: Error,
        roles: OrdersSettings
    },
    {
        component: <PacedDetailModuleItem/>,
        path: '/organization/module/:moduleId/:moduleName/paced-detail/:pacedDetailId/:position',
        errorElement: Error,
        roles: OrdersSettings
    },
    {
        component: <PackagingSetItemAddUnit/>,
        path: '/organization/packaging-sets-units/:id/:article',
        errorElement: Error,
        roles: OrdersSettings
    },
    {
        component: <OrderItem/>,
        path: '/organization/orders/:id/:number/:idHeader/:year',
        errorElement: Error,
        roles: OrdersSettings
    },
    {
        component: <OrderItem constructors={true}/>,
        path: '/organization/constructors/:id/:number/:idHeader/:year',
        errorElement: Error,
        roles: OrdersSettings
    },
    {
        component: <OrderItem developed={true}/>,
        path: '/organization/developed/:id/:number/:idHeader/:year',
        errorElement: Error,
        roles: OrdersSettings
    },

    //Users
    {component: <Users/>, path: '/organization/users', errorElement: Error, roles: OrdersSettings},
    {component: <UsersItem/>, path: '/organization/users/:id/:name', errorElement: Error, roles: OrdersSettings},
    {
        component: <RatingsWorker/>,
        path: '/organization/workers/:id/ratings/:nameWorker',
        errorElement: Error,
        roles: OrdersSettings
    },
    {component: <Paths/>, path: '/organization/paths', errorElement: Error, roles: OrdersSettings},

    //TechnicalMap
    //*OrdersTechnicalMap*
    {
        component: <TechnicalMap/>,
        path: '/organization/technical-map/:id/:order',
        errorElement: Error,
        roles: OrdersTechnicalMap
    },
    {component: <TechnicalMaps/>, path: '/organization/technical-maps', errorElement: Error, roles: OrdersTechnicalMap},
    {
        component: <WorkerJob/>,
        path: '/organization/job-workers/:id/:jobName/:jobMaterial',
        errorElement: Error,
        roles: OrdersWorkerJob
    },

    //Estimate
    //*OrdersEstimates*
    {
        component: <OrganizationEstimate/>,
        path: '/organization/orders/:orderId/:orderNumber/:orderHeaderId/:year/estimate/:estimateId/:estimateState',
        errorElement: Error,
        roles: OrdersEstimates
    },
    {
        component: <ReservationMaterialEstimateUnit/>,
        path: '/organization/orders/:orderId/:orderNumber/:orderHeaderId/:year/estimates/:estimateId/:estimateState/:isButtonPurchase/reservation/:materialEstimateUnitId/:isSlab/:name/:articleNumber/:type/:isIssue/:status/:baseUnit',
        errorElement: Error,
        roles: OrdersEstimates
    },
    {
        component: <ReservationMaterialEstimateUnitPurchase/>,
        path: '/organization/orders/:orderId/:orderNumber/estimates/:estimateId/:estimateState/:isButtonPurchase/reservation/:materialEstimateUnitId/:isSlab/:name/:articleNumber/:type/:isIssue/:status/:baseUnit',
        errorElement: Error,
        roles: OrdersEstimates
    },

    //storage
    //*StorageMaterials*
    {component: <Materials/>, path: '/organization/materials', errorElement: Error, roles: StorageMaterials},
    {
        component: <MaterialItem/>,
        path: '/organization/materials/:id/:baseUnit/:typeMaterial/:materialId',
        errorElement: Error,
        roles: StorageMaterials
    },
    {component: <Materials/>, path: '/organization/materials', errorElement: Error, roles: StorageMaterials},
    {
        component: <MaterialWarehouseArchive/>,
        path: '/organization/materials/:id/:baseUnit/:typeMaterial/:materialId/warehouse-material/archive/:materialName',
        errorElement: Error,
        roles: StorageMaterials
    },
    {
        component: <MaterialWarehouseChildren/>,
        path: '/organization/materials/:id/:baseUnit/:typeMaterial/:materialId/:nameMaterial/children/:childrenId',
        errorElement: Error,
        roles: StorageMaterials
    },
    {
        component: <ReserveWareHouseTable/>,
        path: '/organization/materials/:id/:baseUnit/:typeMaterial/:materialId/:nameMaterial/reserve-warehouse/:materialWarehouseId',
        errorElement: Error,
        roles: StorageMaterials
    },
    {
        component: <ReserveArrival/>,
        path: '/organization/materials-price-unit-arrival/:arrivalMaterialId/:arrivalMaterial/:currentCurrency/:supplierId/:warehouseId/reserve-arrival/:id/:typeMaterial/:baseUnit',
        errorElement: Error,
        roles: StorageMaterials
    },
    //*StorageMaterialsArrival*
    {
        component: <ArrivalMaterial/>,
        path: '/organization/materials-arrival',
        errorElement: Error,
        roles: StorageMaterialsArrival
    },
    {
        component: <ArrivalMaterialArchive/>,
        path: '/organization/materials-arrival-archive',
        errorElement: Error,
        roles: StorageMaterialsArrival
    },
    {
        component: <ArrivalMaterialPriceUnit/>,
        path: '/organization/materials-price-unit-arrival/:arrivalMaterialId/:arrivalMaterial/:currentCurrency/:supplierId/:warehouseId',
        errorElement: Error,
        roles: StorageMaterialsArrival
    },
    {
        component: <ArrivalMaterialPriceUnitArchive/>,
        path: '/organization/materials-price-unit-arrival-archive/:arrivalMaterialId/:arrivalMaterial/:currentCurrency/:supplierId/:warehouseId',
        errorElement: Error,
        roles: StorageMaterialsArrival
    },
    {
        component: <ArrivalMaterialItem/>,
        path: '/organization/materials-price-unit-arrival-item/:itemId/:baseUnit/:orderId/:nameOrder/:materialEstimateUnitId/:estimateId/:estimateState/:name/:articleNumber/:status/:readOnly/:isButtonPurchase/:isSlab',
        errorElement: Error,
        roles: StorageMaterialsArrival
    },
    {
        component: <ArrivalMaterialItem isEstimate={true}/>,
        path: '/organization/materials-price-unit-arrival-item/:itemId/:baseUnit/:orderId/:nameOrder/:materialEstimateUnitId/:estimateId/:estimateState/:name/:articleNumber/:status/:readOnly/isEstimate/:orderHeaderId/:year/:isIssue/:type/:isButtonPurchase/:isSlab',
        errorElement: Error,
        roles: StorageMaterialsArrival
    },

    {
        component: <ArrivalMaterialItemFromIssuance/>,
        path: '/organization/materials-price-unit-arrival-item/issuance-piece-materials/:itemId/:typeMaterial/:baseUnit/:orderId/:nameOrder/:materialEstimateUnitId/:name/:readOnly',
        errorElement: Error,
        roles: StorageMaterialsArrival
    },
    {
        component: <ArrivalMaterialItemReserveWarehouse/>,
        path: '/organization/materials-price-unit-arrival-item/reserve-warehouse/:itemId/:typeMaterial/:baseUnit/:id/:materialId/:name/:readOnly',
        errorElement: Error,
        roles: StorageMaterialsArrival
    },
    {
        component: <ArrivalMaterialItemReserveIssuingEdge/>,
        path: '/organization/materials-price-unit-arrival-item/reserve-issuingEdge/:itemId/:typeMaterial/:baseUnit/:id/:issuingNumber/:readOnly',
        errorElement: Error,
        roles: StorageMaterialsArrival
    },
    {
        component: <ArrivalMaterialItemReserveArrival/>,
        path: '/organization/materials-price-unit-arrival-item/reserve-arrival/:itemId/:arrivalMaterialId/:arrivalMaterial/:currentCurrency/:supplierId/:warehouseId/:id/:typeMaterial/:baseUnit/:readOnly',
        errorElement: Error,
        roles: StorageMaterialsArrival
    },


    {
        component: <OrganizationSupplierMaterialArchiveItem/>,
        path: 'organization/supplier-material-archive-item/:id/:baseUnit/:typeMaterial/:materialId',
        errorElement: Error,
        roles: StorageMaterialsArrival
    },
    {
        component: <OrganizationMaterialFixedStripeArchiveItem/>,
        path: 'organization/material-fixed-archive-item/:id/:baseUnit/:typeMaterial/:materialId',
        errorElement: Error,
        roles: StorageMaterialsArrival
    },
    {
        component: <OrganizationMaterialMinStripeArchiveItem/>,
        path: 'organization/material-min-archive-item/:id/:baseUnit/:typeMaterial/:materialId',
        errorElement: Error,
        roles: StorageMaterialsArrival
    },

    //*StorageRequestsPurchase*
    {
        component: <RequestsPurchase/>,
        path: '/organization/requests-purchase',
        errorElement: Error,
        roles: StorageRequestsPurchase
    },
    {
        component: <RequestsPurchaseItem/>,
        path: '/organization/requests-purchase/:estimateId/:orderId/:orderNumber/:status',
        errorElement: Error,
        roles: StorageRequestsPurchase
    },
    {
        component: <FormationRequestsPurchase/>,
        path: '/organization/formation-requests-purchase',
        errorElement: Error,
        roles: StorageRequestsPurchase
    },
    {
        component: <ReservationPieceMaterial/>,
        path: '/organization/reservation-piece-material',
        errorElement: Error,
        roles: StorageReservationPieceMaterial
    },
    {
        component: <ReservationSlabMaterial/>,
        path: '/organization/reservation-slab-material',
        errorElement: Error,
        roles: StorageReservationSlabMaterial
    },
    {
        component: <ReservationLinerMaterial/>,
        path: '/organization/reservation-linear-material',
        errorElement: Error,
        roles: StorageReservationLinearMaterial
    },

    //*StorageSettingsStorage*
    {component: <Units/>, path: '/organization/units', errorElement: Error, roles: StorageSettingsStorage},
    {
        component: <SupplierItem/>, path: '/organization/suppliers/:supplierId', errorElement: Error,
        roles: StorageSettingsStorage
    },
    {
        component: <CurrentCurrencyNationalBank/>, path: '/organization/current-currencies', errorElement: Error,
        roles: StorageCurrentCurrencies
    },

    //Optimization
    //*RequestsCutting*
    {
        component: <RequestsCuttingsAll/>, path: '/organization/requests-cutting', errorElement: Error,
        roles: RequestsCutting
    },
    {
        component: <RequestsCuttingsArchive/>, path: '/organization/requests-cutting/archive', errorElement: Error,
        roles: RequestsCutting
    },
    {
        component: <Processing organization={true} isReserve={true}/>,
        path: '/organization/requests-cutting/reserve/:id',
        errorElement: Error,
        roles: RequestsCutting
    },
    {
        component: <Processing organization={true} isWarehouse={true}/>,
        path: '/organization/requests-cutting/warehouse/:id',
        errorElement: Error,
        roles: RequestsCutting
    },
    {
        component: <DetailsRequestsCutting/>,
        path: '/organization/requests-cutting/details/:id/:numberRequestsCutting',
        errorElement: Error,
        roles: RequestsCutting
    },
    {
        component: <DetailsRequestsCutting/>,
        path: '/organization/requests-cutting/details/:id/:numberRequestsCutting/:cloud',
        errorElement: Error,
        roles: RequestsCutting
    },
    {
        component: <Processing organization={true}/>,
        path: '/organization/requests-cutting/details/:requestsCuttingId/:numberRequestsCutting/detail/:id',
        errorElement: Error,
        roles: RequestsCutting
    },
    {
        component: <Processing organization={true} isDetailModel={true}/>,
        path: '/organization/requests-cutting/detail-model/:id',
        errorElement: Error,
        roles: RequestsCutting
    },
    {
        component: <Processing organization={true} composition={true}/>,
        path: '/organization/requests-cutting/composition/:id',
        errorElement: Error,
        roles: RequestsCutting
    },

    {
        component: <Processing organization={true}/>,
        path: '/organization/basic-models/:modelId/estimates/:estimateId/:estimateNumber/detail/:id',
        errorElement: Error,
        roles: RequestsCutting
    },

    //*OptimizationOptimization*
    {
        component: <RequestsCuttingOptimization/>,
        path: '/organization/requests-cutting/optimization/:optimizationId/:name',
        errorElement: Error,
        roles: OptimizationOptimization
    },
    {
        component: <RequestsCuttingCalculationOptimization/>,
        path: '/organization/requests-cutting/optimization/:optimizationId/:name/calculation',
        errorElement: Error,
        roles: OptimizationOptimization
    },
    {
        component: <DetailsRequestsCuttingOptimization/>,
        path: '/organization/details/optimization/:optimizationId/:number',
        errorElement: Error,
        roles: OptimizationOptimization
    },
    {
        component: <Optimizations/>, path: '/organization/optimizations', errorElement: Error,
        roles: OptimizationOptimization
    },
    {
        component: <DetailReserve/>, path: '/organization/detail-reserve', errorElement: Error,
        roles: OptimizationOptimization
    },

    {
        component: <DetailWarehouse/>, path: '/organization/detail-warehouse', errorElement: Error,
        roles: OptimizationOptimization
    },

    {
        component: <OptimizationsArchive/>, path: '/organization/optimizations-archive', errorElement: Error,
        roles: OptimizationOptimization
    },
    {
        component: <RequestCustomizedMaterials/>,
        path: '/organization/requests-customized-materials',
        errorElement: Error,
        roles: CustomizedMaterialsDetails
    },
    {
        component: <RequestCustomizedMaterialsDetails/>,
        path: '/organization/requests-customized-materials-details',
        errorElement: Error,
        roles: CustomizedMaterialsDetails
    },

    //*Plan*
    {
        component: <Plans/>, path: '/organization/plans', errorElement: Error,
        roles: Plan
    },
    {
        component: <RequestsCuttingPlan/>,
        path: '/organization/requests-cutting/plan/:planId/:name',
        errorElement: Error,
        roles: Plan
    },
    {
        component: <PlanItem/>, path: '/organization/plans/:id/:name', errorElement: Error,
        roles: Plan
    },

    //Cutting
    //*CuttingWorkingCuttingMaps*
    {
        component: <WorkingCuttingMaps/>, path: '/organization/working-cutting-maps', errorElement: Error,
        roles: CuttingWorkingCuttingMaps
    },
    {
        component: <WorkingCuttingMapsArchive/>,
        path: '/organization/working-cutting-maps-archive',
        errorElement: Error,
        roles: CuttingWorkingCuttingMaps
    },
    {
        component: <WorkingCuttingMapsCalculationArchive/>,
        path: '/organization/working-cutting-maps-calculation-archive',
        errorElement: Error,
        roles: CuttingWorkingCuttingMaps
    },
    {
        component: <WorkingCuttingMapItem/>,
        path: '/organization/working-cutting-map/:workingCuttingMapId/vector/:nameMaterial/:number/:materialOId/:cloud',
        errorElement: Error,
        roles: CuttingWorkingCuttingMaps
    },
    {
        component: <WorkingCuttingMapItem/>,
        path: '/organization/working-cutting-map/:workingCuttingMapId/vector/:nameMaterial/:number/:materialOId',
        errorElement: Error,
        roles: CuttingWorkingCuttingMaps
    },
    {
        component: <WorkingCuttingMapItem/>,
        path: '/organization/working-cutting-map/:workingCuttingMapId/image/:nameMaterial/:number/:materialOId/:cloud',
        errorElement: Error,
        roles: CuttingWorkingCuttingMaps
    },
    {
        component: <WorkingCuttingMapItem/>,
        path: '/organization/working-cutting-map/:workingCuttingMapId/image/:nameMaterial/:number/:materialOId',
        errorElement: Error,
        roles: CuttingWorkingCuttingMaps
    },
    {
        component: <WorkingCuttingMapItem/>,
        path: '/organization/working-cutting-map/:workingCuttingMapId/:nameMaterial/:number/:materialOId/:cloud',
        errorElement: Error,
        roles: CuttingWorkingCuttingMaps
    },
    {
        component: <WorkingCuttingMapItem/>,
        path: '/organization/working-cutting-map/:workingCuttingMapId/:nameMaterial/:number/:materialOId',
        errorElement: Error,
        roles: CuttingWorkingCuttingMaps
    },
    {
        component: <WarehouseFinishedDetail/>,
        path: '/organization/warehouse-finished-detail',
        errorElement: Error,
        roles: CuttingWorkingCuttingMaps
    },

    //cut-file
    //*CuttingQueueCuttingMaps*
    {
        component: <CutFile/>,
        path: '/organization/working-cutting-map/:workingCuttingMapId/:nameMaterial/cut-files',
        errorElement: Error,
        roles: [...CuttingQueueCuttingMaps, ...CuttingWorkingCuttingMaps]
    },
    {
        component: <QueueCuttingMaps/>,
        path: '/organization/queue-cutting-maps',
        errorElement: Error,
        roles: CuttingQueueCuttingMaps
    },

    //PRODUCTION
    {
        component: <OrdersProduction/>,
        path: '/organization/orders-production',
        errorElement: Error,
        roles: OrderPRODUCTIONPRODUCTION
    },
    {
        component: <OrdersCustomerProduction/>,
        path: '/customer/orders-production',
        errorElement: Error,
        roles: OrderPRODUCTIONPRODUCTION
    },

    //*OrderPRODUCTIONIssuingEdges*
    {
        component: <IssuingEdges/>, path: '/organization/issuing-edges', errorElement: Error,
        roles: OrderPRODUCTIONIssuingEdges
    },
    {
        component: <IssuingEdgesArchive/>, path: '/organization/issuing-edges-archive', errorElement: Error,
        roles: OrderPRODUCTIONIssuingEdges
    },
    {
        component: <IssuingEdge/>, path: '/organization/issuing-edges/:id/:number', errorElement: Error,
        roles: OrderPRODUCTIONIssuingEdges
    },
    {
        component: <IssuingEdgeReservation/>,
        path: '/organization/issuing-edges/:id/:number/:materialWarehouseId',
        errorElement: Error,
        roles: OrderPRODUCTIONIssuancePieceMaterials
    },
    {
        component: <IssuanceWarehouseMaterial/>,
        path: '/organization/issuance-warehouse-material/:id',
        errorElement: Error,
        roles: OrderPRODUCTIONIssuingEdges
    },
    {
        component: <IssuanceWarehouseMaterialCurrentIssuingEdge/>,
        path: '/organization/:issuingEdgeId/issuance-warehouse-material/:id',
        errorElement: Error,
        roles: OrderPRODUCTIONIssuingEdges
    },
    {
        component: <IssuanceIssuingEdgesItem/>,
        path: '/organization/issuance-issuing-edges-item/:id',
        errorElement: Error,
        roles: OrderPRODUCTIONIssuingEdges
    },
    {
        component: <IssuanceMaterialReserve/>, path: '/organization/issuance-material-reserve/:id', errorElement: Error,
        roles: OrderPRODUCTIONIssuingEdges
    },
    //*OrderPRODUCTIONIssuancePieceMaterials*
    {
        component: <IssuancePieceMaterials/>, path: '/organization/issuance-piece-materials', errorElement: Error,
        roles: OrderPRODUCTIONIssuancePieceMaterials
    },
    {
        component: <IssuancePieceMaterialsItem/>,
        path: '/organization/issuance-piece-materials/:id/:order',
        errorElement: Error,
        roles: OrderPRODUCTIONIssuancePieceMaterials
    },
    {
        component: <IssuanceReservationMaterialEstimateUnit/>,
        path: '/organization/issuance-piece-materials/:orderId/:orderNumber/:eId/:type/:nameMaterial/:baseUnit',
        errorElement: Error,
        roles: OrderPRODUCTIONIssuancePieceMaterials
    },
    //economic
    {
        component: <AllIssuanceMaterialReserve/>, path: '/organization/issuance-material-reserve', errorElement: Error,
        roles: EconomicIssuanceMaterialReserve
    },
    {
        component: <InWork/>,
        path: '/organization/in-work',
        errorElement: Error,
        roles: EconomicInWork
    },
    {
        component: <InStock/>,
        path: '/organization/in-stock',
        errorElement: Error,
        roles: EconomicInWork
    },
    {
        component: <BalanceSheet/>,
        path: '/organization/balance-sheet',
        errorElement: Error,
        roles: EconomicInWork
    },
    {
        component: <Salary/>,
        path: '/organization/salary',
        errorElement: Error,
        roles: EconomicInWork
    },


    //material-cloud
    //*Material_Cloud*
    {component: <AllMaterials/>, path: '/all-materials', errorElement: Error, roles: MaterialCloud},
    {
        component: <AllMaterialItem/>,
        path: '/all-materials/:id/:baseUnit/:typeMaterial',
        search: '?isSettings',
        errorElement: Error,
        roles: MaterialCloud
    },
    {
        component: <SettingsCloud/>,
        path: '/settings-cloud',
        errorElement: Error,
        roles: MaterialCloudAdminRoles
    },
    {
        component: <SettingsCloudLoadGroupMaterial/>,
        path: '/settings-cloud-load-group',
        errorElement: Error,
        roles: MaterialCloudAdminRoles
    },
    {
        component: <SettingsCloudLoadMaterial/>,
        path: '/settings-cloud-load-material',
        errorElement: Error,
        roles: MaterialCloudAdminRoles
    },
    {
        component: <SupplierMaterialArchiveItem/>,
        path: '/all-materials/supplier-material-archive-item/:materialId/:baseUnit/:typeMaterial/:materialId',
        errorElement: Error,
        roles: MaterialCloudAdminRoles
    },
    {
        component: <MaterialFixedStripeArchiveItem/>,
        path: '/all-materials/supplier-material-fixed-archive-item/:materialId/:baseUnit/:typeMaterial/:materialId',
        errorElement: Error,
        roles: MaterialCloudAdminRoles
    },
    {
        component: <MaterialMinStripeArchiveItem/>,
        path: '/all-materials/supplier-material-min-archive-item/:materialId/:baseUnit/:typeMaterial/:materialId',
        errorElement: Error,
        roles: MaterialCloudAdminRoles
    },

    //{component: <DatabaseOfMaterials/>, path: '/organization/database-of-materials', errorElement: Error, roles: Orders_roles},
    //customer
    {
        component: <CustomerOrders/>,
        path: '/customer/orders',
        search: '?create=type',
        errorElement: Error,
        roles: CustomerRoles
    },
    {
        component: <CustomerOrders kitchenOrders/>,
        path: '/customer/kitchen-orders',
        errorElement: Error,
        roles: CustomerRoles
    },
    {
        component: <CustomerOrdersArchive/>,
        path: '/customer/archive',
        errorElement: Error,
        roles: CustomerRoles
    },
    {
        component: <CustomerOrderCompositionPage/>,
        path: '/customer/orders/:id',
        errorElement: Error,
        roles: CustomerRoles
    },
    {
        component: <CustomerOrderItem/>,
        path: '/customer/orders/:id/:customerOrderNumber/:year',
        errorElement: Error,
        roles: CustomerRoles
    },
    {
        component: <CustomerOrderItemImport3DMessages/>,
        path: '/customer/orders/:id/:customerOrderNumber/:year/messages/:import3DId',
        errorElement: Error,
        roles: CustomerRoles
    },
    {
        component: <CustomerOrderOffers/>,
        path: '/customer/orders/:orderId/:customerOrderNumber/:year/estimates',
        errorElement: Error,
        roles: OrdersEstimates
    },
    {
        component: <CustomerOrganizationEstimateItem/>,
        path: '/customer/orders/:orderId/:customerOrderNumber/estimates/:estimateId/:base/:alternative/:organizationName/:estimateState',
        errorElement: Error,
        roles: OrdersEstimates
    },
    //customer
    {
        component: <CustomerRequestsCutting/>,
        path: '/customer/orders/:orderId/:customerOrderNumber/:year/requests-cutting/:requestsCuttingId/:requestsCuttingNumber/details',
        errorElement: Error,
        roles: CustomerRequestsCuttingRoles
    },
    {
        component: <Processing/>,
        path: '/customer/orders/:orderId/:customerOrderNumber/:year/requests-cutting/:requestsCuttingId/:requestsCuttingNumber/details/:id',
        search: '?materialId=type',
        errorElement: Error,
        roles: CustomerRequestsCuttingRoles
    },
    {
        component: <Processing/>,
        path: '/customer/orders/:orderId/:customerOrderNumber/:year/requests-cutting/details/:id',
        errorElement: Error,
        roles: CustomerProcessing
    },
    {
        component: <Processing/>,
        path: '/customer/samples/details/:id',
        errorElement: Error,
        roles: CustomerProcessing
    },
    {
        component: <Samples/>,
        path: '/customer/samples',
        errorElement: Error,
        roles: CustomerRoles
    },
    {
        component: <SamplesGroups/>,
        path: '/customer/groups',
        errorElement: Error,
        roles: CustomerRoles
    },
    {
        component: <SamplesEdges/>,
        path: '/customer/samples/edges',
        errorElement: Error,
        roles: CustomerRoles
    },
    {
        component: <Samples system={true}/>,
        path: '/customer/system-samples',
        errorElement: Error,
        roles: CustomerRoles
    },


    //{component: <DatabaseOfMaterials/>, path: '/database-of-materials', errorElement: Error, roles: Orders_roles},

]
